export const canvasColors = [
  "amber",
  "olive",
  "green",
  "turquoise",
  "blue",
  "purple",
  "pink",
  "red",
  "grey",
];
export type CanvasColor = typeof canvasColors[number];
